import { getElementTotalTimesLengthMs, getStartTime } from 'JS/playback/lib/Playback/helpers/timings';
import { mapSceneElementIdsToElements } from 'JS/shared/helpers/scenesHelpers';

export default function getCursorTimings(scribe) {
  const defaultCursor = scribe.cursor;

  const cursorTimings = scribe.scenes
    .flatMap(scene => mapSceneElementIdsToElements(scribe, scene))
    .map(element => {
      const startTime = getStartTime(scribe, element.id);
      const length = getElementTotalTimesLengthMs(element, scribe);

      return {
        startTime,
        cursorId: element.cursorId || defaultCursor,
        endTime: startTime + length
      };
    })
    .reduce((prev, cursorTime, i, arr) => {
      if (prev[prev.length - 1]?.cursorId === cursorTime.cursorId) {
        prev[prev.length - 1].endTime = cursorTime.endTime;
      } else {
        prev.push(cursorTime);
      }

      return prev;
    }, []);

  return cursorTimings;
}
